import { MessageListTypeEnum } from '../../../views/messaging/enums/message-list-type.enum';
import { IMessage, IMessageFilters } from '../../interfaces/messaging.interface';

export class GetSendedMessages {
    public static readonly type = '[Messaging] get sended';
    constructor(public filters?: IMessageFilters) {}
}

export class GetReceivedMessages {
    public static readonly type = '[Messaging] get received';
    constructor(public filters?: IMessageFilters) {}
}

export class GetArchivedMessages {
    public static readonly type = '[Messaging] get archived';
    constructor(public filters?: IMessageFilters) {}
}

export class SearchMessages {
    public static readonly type = '[Messaging] search';
    constructor(public search: string, public msgType: MessageListTypeEnum, public filters?: IMessageFilters) {}
}

export class ResetMessageList {
    public static readonly type = '[Messaging] reset message list';
    constructor(public listType: MessageListTypeEnum) {}
}

export class ResetMessagesSearch {
    public static readonly type = '[Messaging] reset search';
}

export class SendMessage {
    public static readonly type = '[Messaging] send message';
    constructor(public message: IMessage) {}
}

export class MarkAsViewed {
    public static readonly type = '[Messaging] mark as viewed';
    constructor(public messageId: number) {}
}

export class ArchiveMessage {
    public static readonly type = '[Messaging] archive';
    constructor(public messageId: number) {}
}

export class UnarchiveMessage {
    public static readonly type = '[Messaging] unarchive';
    constructor(public messageId: number) {}
}

export class GetUnreadMessagesCount {
    public static readonly type = '[Unread messages] get count';
}

export class ResetMessages {
    public static readonly type = '[Messaging] reset state';
}

export class GetMessageById {
    public static readonly type = '[Message] get by id';
    constructor(public messageId: number) {}
}

export class SetCurrentMessage {
    public static readonly type = '[Message] set current';
    constructor(public message: IMessage) {}
}

export class CleanCurrentMessage {
    public static readonly type = '[Message] clean current';
}
